import { Component, OnInit, inject } from '@angular/core';
import { AssignmentBoardComponent } from '../components/assignment-board/assignment-board.component';
import { HomeDataService } from '../services/home-data.service';

@Component({
  selector: 'app-home-assignments-view',
  standalone: true,
  imports: [AssignmentBoardComponent],
  template: `<app-assignment-board />`,
  styles: [`
    :host {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      width: 100%;
      min-height: 0;
    }

    app-assignment-board {
      flex: 1 1 auto;
      min-height: 0;
    }
  `],
})
export class HomeAssignmentsViewComponent implements OnInit {
  #homeData = inject(HomeDataService);

  ngOnInit(): void {
    this.#homeData.prefetchDuties();
  }
}
